/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default FallbackCom => Comp => {
	class components extends Component {
		constructor(props) {
			super(props);
			this.state = { hasError: false };
		}

		static propTypes = {
			children: PropTypes.any,
		};

		componentDidCatch(error, info) {
			// Display fallback UI
			this.setState({ hasError: true });
			// You can also log the error to an error reporting service
            console.error('something wrong happened; error:', error); // eslint-disable-line
            console.info('something wrong happened; info:', info); // eslint-disable-line
		}

		render() {
			if (FallbackCom && this.state.hasError) {
				return FallbackCom;
			}

			return <Comp {...this.props} />;
		}
	}
	components.WrappedComponent = Comp;

	return components;
};
